import { useNavigate } from 'react-router-dom';
import { routes } from '../../../common/routes';
import DialogTemplate from '../../Common/DialogTemplate';
import { Icon, Label, Text, ColorPicker, IColor } from '@fluentui/react';

interface IPlanillaYaIniciadaErrorDialog {
  showPlanillaYaIniciadaError: boolean;
  setShowPlanillaYaIniciadaError: (v: boolean) => void;
}

const PlanillaYaIniciadaErrorDialog = ({
  showPlanillaYaIniciadaError,
  setShowPlanillaYaIniciadaError,
}: IPlanillaYaIniciadaErrorDialog) => {
  const navigate = useNavigate();

  return (
    <DialogTemplate
      showDialog={showPlanillaYaIniciadaError}
      toggleShowDialog={() => {
        navigate(routes.planilla_partido_programado.route);
      }}
      title={'No se puede acceder a esta planilla'}
      onAccept={() => {
        navigate(routes.planilla_partido_programado.route);
      }}
      onCancel={() => {
        navigate(routes.planilla_partido_programado.route);
      }}
      acceptText={'Volver a partidos programados'}
      cancelText={''}
      hideCancelButton
      minWidth={800}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <Text style={{ display: 'block', fontWeight: 400, fontSize: 16 }}>
              <Icon
                iconName="AlertSolid"
                className="error-color"
                style={{ position: 'relative', top: '3px', marginRight: 2, fontSize: 16 }}
              ></Icon>
              La planilla se encuentra en juego, para poder continuar trabajando con la misma deberá ingresar
              desde el sistema
            </Text>

            <div className="ms-Grid-col ms-lg4  mt-2"></div>
          </div>
        </div>
      </div>
    </DialogTemplate>
  );
};

export default PlanillaYaIniciadaErrorDialog;
